export default __webpack_public_path__ + "static/media/Close-black.80eaaeca.svg";